module.exports = __webpack_public_path__ + "static/media/piggybank.59edebe1.png";